import { render, staticRenderFns } from "./Vueltos.vue?vue&type=template&id=6df48a66&scoped=true"
import script from "./Vueltos.vue?vue&type=script&lang=js"
export * from "./Vueltos.vue?vue&type=script&lang=js"
import style0 from "./Vueltos.vue?vue&type=style&index=0&id=6df48a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df48a66",
  null
  
)

export default component.exports